import React from 'react'
import { ProviderItemViewModel, ReportSectionCode } from '@/interfaces'
import { Text, View } from '@react-pdf/renderer'
import Table from './Table'
import { helper, providers } from '@/utils'

interface Props {
  metalProcessingProvider?: ProviderItemViewModel | null
  bladeProcessingProvider?: ProviderItemViewModel | null
  concreteProcessingProvider?: ProviderItemViewModel | null
  styles?: any
  texts?: any
  setPages?: any
  printSections: number[]
}

const { convertOptionsToTableRows } = helper
const { buildProviderData } = providers

const ReportMaterialProcessingPage: React.FC<Props> = ({
  metalProcessingProvider,
  bladeProcessingProvider,
  concreteProcessingProvider,
  styles,
  texts,
  printSections
}) => {
  return (
    <View>
      <View />
      <Text id="materialprocessing" style={styles.subTitle}>
        {printSections
          .sort()
          .findIndex(value => value === ReportSectionCode.WindFarmCircularity) +
          1}
        .2. Material processing
      </Text>
      <Text style={styles.paragraph}>
        {texts?.report.materialProcessing.intro}
      </Text>
      {!!metalProcessingProvider && (
        <Table
          name="Metal processing"
          description={metalProcessingProvider?.name}
          rows={convertOptionsToTableRows(
            buildProviderData(metalProcessingProvider, true) as any
          )}
          breakPage={false}
        />
      )}
      {!!bladeProcessingProvider && (
        <Table
          name="Blade processing"
          description={bladeProcessingProvider?.name}
          rows={convertOptionsToTableRows(
            buildProviderData(bladeProcessingProvider, true) as any
          )}
          breakPage={false}
        />
      )}
      {!!concreteProcessingProvider && (
        <Table
          name="Concrete processing"
          description={concreteProcessingProvider?.name}
          rows={convertOptionsToTableRows(
            buildProviderData(concreteProcessingProvider, true) as any
          )}
          breakPage={false}
        />
      )}
    </View>
  )
}

export default ReportMaterialProcessingPage
